import { assert } from '../errors';

export const integerCentsFromDollarsFloat = (currencyFloat: number): number => {
    return Math.round(currencyFloat * 100);
};

export const roundCentsToNearestDollar = (numInCents: number): number => {
    return Math.round(numInCents / 100) * 100;
};

const dollarsWithCentsFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

const dollarsWithoutCentsFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});

export function toDollars(
    numInCents: number,
    opts: { withCents: boolean; alwaysSigned?: boolean } = {
        withCents: false,
        alwaysSigned: false,
    }
): string {
    assert(Number.isInteger(numInCents), 'Cents must be integer');

    const num = numInCents / 100.0;
    const result = opts.withCents
        ? dollarsWithCentsFormatter.format(num)
        : dollarsWithoutCentsFormatter.format(num);

    if (opts.alwaysSigned) {
        return num > 0 ? `+${result}` : result;
    } else {
        return result === '-$0' ? '$0' : result;
    }
}

export function toDollarsWithCents(numInCents: number): string {
    return toDollars(numInCents, { withCents: true });
}
